/**
 * How far every page control sits from the screen's edges (px): corner buttons, edge bars, a
 * docked tray's buttons, a corner action, and the camera column. One number so the screen's
 * margins are the same all round (owner, 2026-10-13: "a bit closer to the edges ... consistent
 * around all edges"; was 18, the camera column 8).
 */
export const EDGE_INSET = 10
